import React from 'react';
import Header from '../components/layout/Header';
import SideMenu from '../components/layout/SideMenu';
import styles from './PrivacyPolicyPage.module.css';
import layoutStyles from '../styles/layout.module.css';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className={layoutStyles.pageContainer}>
      <Header />
      <div className={styles.mainLayout}>
        <SideMenu />
        <main className={styles.contentArea}>
          <section className={styles.headerSection}>
            <h1 className={styles.title}>Privacy Policy</h1>
            <p className={styles.subtitle}>
              This Privacy Policy explains how Moujood collects, uses, and protects information in this web dashboard.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>1. Information We Collect</h2>
            <p className={styles.sectionText}>
              We collect information you provide directly, such as account details, store information, and content you
              manage through this dashboard. We may also collect technical information about your usage, including IP
              address, browser type, and access times.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>2. How We Use Information</h2>
            <p className={styles.sectionText}>
              We use your information to provide and improve Moujood services, manage your store data, secure your
              account, and communicate with you about updates or support. We may also use aggregated and anonymized data
              for analytics and service optimization.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>3. Data Sharing</h2>
            <p className={styles.sectionText}>
              We do not sell your personal information. We may share data with trusted service providers that help us
              operate the platform, with authorities when required by law, or in connection with a merger, acquisition,
              or similar event.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>4. Security</h2>
            <p className={styles.sectionText}>
              We use reasonable technical and organizational measures to protect your information. However, no system is
              completely secure, and you are responsible for keeping your login credentials confidential.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>5. Your Rights</h2>
            <p className={styles.sectionText}>
              Depending on your location, you may have rights to access, update, or delete certain personal information.
              To exercise these rights, contact our support team using the contact details provided in the main Moujood
              application or your onboarding documentation.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>6. Updates to This Policy</h2>
            <p className={styles.sectionText}>
              We may update this Privacy Policy from time to time. When we make changes, we will update the effective
              date and, where required, notify you through the dashboard or other communication channels.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;

